<template>
  <div class="calendar-event-list">
    <WholeCalendarToolbar
      :date-moment="dateMoment"
      time-range="year"
      @date-change="$emit('date-change', $event)"
    />
    <div class="calendar-event-list__content">
      <div
        v-for="(month, monthKey) in _eventsInMonth"
        :key="monthKey"
        class="calendar-event-list__item"
      >
        <div class="calendar-event-list__month">
          {{ $t(`${monthKey}月`) }}
        </div>
        <div class="calendar-event-list__types">
          <div
            v-for="(eventType, eventTypeKey) in eventTypes"
            :key="eventTypeKey"
            class="calendar-event-list__type"
          >
            <div class="title">
              <img v-if="eventType.iconImage" class="type-icon" :src="eventType.iconImage" alt="" />
              <LvIcon v-else :class="eventType.icon" size="30px" color=""></LvIcon>
              <p>{{ eventType.text }}</p>
            </div>
            <div class="number">
              {{ $_getEventTypeNumber(eventType, month.events) }}
            </div>
          </div>
        </div>
        <div class="calendar-event-list__evnets">
          <div
            v-for="(event, eventKey) in month.events"
            :key="eventKey"
            class="calendar-event-list__evnet"
            @click="$_handleEventClick(event)"
          >
            <div class="date">
              {{ $_getMonthEventDateFormat(event) }}
            </div>
            <img
              v-if="$_getEventTypeIcon(event.eventType)"
              class="icon"
              :src="$_getEventTypeIcon(event.eventType)"
              alt=""
            />
            <LvIcon v-else :class="$_getEventIcon(event.eventType)" size="26px" color=""></LvIcon>
            <div class="event-content">
              {{ event.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import WholeCalendarToolbar from './WholeCalendarToolbar.vue';
export default {
  components: {
    WholeCalendarToolbar,
  },
  props: {
    weekdaysName: Array,
    weekdayNumbers: Array,
    dateMoment: Object,
    events: Array,
    eventTypes: Array,
  },
  computed: {
    _tarYearEvents() {
      const _tarYearEvents = [];
      this.events.forEach(event => {
        if (moment(event.date).year() == moment(this.dateMoment).year()) {
          _tarYearEvents.push(event);
        }
      });
      return _tarYearEvents;
    },
    _eventsInMonth() {
      const _eventsInMonth = {};
      for (let i = 0; i < 12; i++) {
        _eventsInMonth[i + 1] = {
          events: [],
        };
      }
      this._tarYearEvents.forEach(event => {
        _eventsInMonth[moment(event.date).month() + 1].events.push(event);
      });
      for (let key in _eventsInMonth) {
        _eventsInMonth[`${key}`].events.sort(function (a, b) {
          return a.date < b.date ? -1 : 1;
        });
      }
      return _eventsInMonth;
    },
  },
  methods: {
    $_handleEventClick($event) {
      this.$emit('event-click', $event);
    },
    $_getEventTypeIcon(eventType) {
      if (!eventType) {
        return null;
      }
      const tarEventType = this.eventTypes.find(e => {
        return e.name == eventType;
      });
      if (!tarEventType) {
        return null;
      } else {
        return tarEventType.iconImage;
      }
    },
    $_getEventIcon(eventType) {
      if (!eventType) {
        return null;
      }
      const tarEventType = this.eventTypes.find(e => e.name == eventType);
      return tarEventType?.icon ?? null;
    },
    $_getMonthEventDateFormat(event) {
      return moment(event.date).format('YYYY-MM-DD');
    },
    $_getEventTypeNumber(eventType, events) {
      let number = 0;
      if (eventType.name == '__other') {
        events.forEach(event => {
          if (!event.eventType) {
            number++;
          }
        });
      } else {
        events.forEach(event => {
          if (event.eventType == eventType.name) {
            number++;
          }
        });
      }
      return number;
    },
  },
};
</script>

<style>
</style>
